import styled from 'styled-components';

import Button from 'components/Buttons/Button';

export const Container = styled.main`
  padding: 56px 16px 32px 16px;
`;

export const Title = styled.h4`
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: center;
  color: ${({ theme }) => theme.confirmation.color};
`;

export const Content = styled.p`
  padding-top: 32px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: ${({ theme }) => theme.confirmation.color};
`;

export const ButtonContainer = styled.section`
  display: flex;
  padding-top: 56px;
  justify-content: center;
  width: 100%;
`;

interface StyledProps {
  red: boolean;
  fullWidth: boolean;
}

export const ConfirmButton = styled(Button).attrs<any, StyledProps>((): any => ({}))`
  width: ${({ fullWidth }) => (fullWidth ? '100%' : '168px')};
  height: 56px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.25;

  ${({ red, theme }) => !red && `background-image: ${theme.confirmation.backgroundConfirmButton}`}
`;

export const CancelButton = styled(Button)`
  width: 168px;
  height: 56px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.25;
  margin-right: 8px;
`;
